import {ChangeDetectionStrategy, Component} from '@angular/core';
import {HeaderComponent} from "./shared/header/header.component";
import {RouterOutlet} from "@angular/router";
import {FooterComponent} from "./shared/footer/footer.component";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports: [
        HeaderComponent,
        RouterOutlet,
        FooterComponent
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./app.component.scss']
})
export class AppComponent {

}

